import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsCloudSolutions(tenant: Tenant): Faq[] {
	return [
		{
			question: "Jaké typy aplikaci vyvíjíte na cloudu?",
			answer:
				"Všechny aplikace, které běží v prohlížeči: od webů přes e-shopy a webové aplikace až po sociální sítě, systémy nebo firemní CRM.",
		},
		{
			question: "Které metody používáte ke snížení nákladů a zvýšení výkonu?",
			answer:
				"Používáme doporučené postupy vhodných cloudových služeb, které mají dostatečnou škálovatelnost a které jsou za přívětivou cenu.",
		},
		{
			question: "Je možné migrovat naši stávající infrastrukturu do IaC, nebo je nutné vytvářet vše od začátku?",
			answer:
				"Migrace do systému IaC z jiného systému není možná jedním kliknutím. IaC kódy píšeme manuálně, což zajišťuje stabilní chod služeb.",
		},
		{
			question: "Jak probíhá testování cloudových aplikací?",
			answer:
				"Na testování cloudových aplikací máme několik postupů a scénářů, které v čase aktualizujeme. Používáme běžné uživatelské manuální testy, emulátory i automatizované testy v kódu.",
		},
	];
}
